import { PaymentsService } from '@festina/moneyin-general-types/moneyin/services/PaymentsService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { Except } from '@festina-life/core'

const method = PaymentsService.paymentsServicePostSettle
type MethodParam = Parameters<typeof method>[0]

export const useSubmitPaymentMatch = ({ tenantId }: { tenantId: string }) =>
  useFestinaMutation({
    component: 'moneyIn',
    roles: PaymentsService.paymentsServicePostSettle_roles,
    isScenario: false,
    mutateFunction: async (arg: Except<MethodParam, 'xTenantId'>) =>
      await method({ xTenantId: tenantId, ...arg }),
  })
